import { useFlag } from '@fhs-legacy/frontend/src/utils/launchdarkly';

// Copied from workspaces/frontend/src/state/apple-pay/hooks/use-can-use-apple-pay.web.ts

export function useApplePayAvailability() {
  const applePayPluginAvailable = useFlag('enable-apple-pay');
  let canMakePayments = false;
  if (window.ApplePaySession) {
    try {
      canMakePayments = ApplePaySession.canMakePayments();
    } catch {
      canMakePayments = false;
    }
  }
  return canMakePayments && applePayPluginAvailable;
}
